import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

interface RenderPackageValueProps {
  type: string;
  value: string;
}
const RenderPackageValue: React.FC<RenderPackageValueProps> = ({
  type,
  value,
}) => {
  return (
    <Box
      sx={{
        borderBottom: "1px solid",
        borderColor: "#EBEAEA",
        py: 0.8,
        px: 1,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Typography sx={{ color: "#5E5B5B", fontSize: 14, fontWeight: 500 }}>
            {type}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Typography
            sx={{
              color: "#5E5B5B",
              fontSize: 14,
              fontWeight: 500,
            }}
          >
            {value}
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RenderPackageValue;
